// Shared validation rule builders for the direct debit bank detail fields
// (account holder name, sort code, account number) used across the various
// B2B PaymentPage.vue views.
//
// The bank fields are optional as a whole set, but as soon as the user starts
// filling in any one of them, all three become required. Call
// `isBankDetailsBlank` with the three field values to compute that flag, then
// pass it into the rule builders below.
import {
  ERROR_MAX_LENGTH_SORT_CODE,
  ERROR_MIN_LENGTH_SORT_CODE,
} from "@/constants/message.constants";
import {
  SORT_CODE_REGEX,
  TEXT_ONLY_REGEX,
  ACCOUNT_NUMBER_REGEX,
} from "@/constants/regex-patterns.constants";

export const isBankDetailsBlank = (sortCode, accountNo, accountName) => {
  return !sortCode && !accountNo && !accountName;
};

export const getBankAccountNameRule = (isBlank) => {
  return {
    regex: {
      pattern: TEXT_ONLY_REGEX,
      customMessage:
        "Please enter only alpha characters, ampersands, spaces and hyphens in this field.",
    },
    maxLength: {
      length: 30,
      fieldLabel: "Account holder name",
    },
    ...(!isBlank && {
      required: { fieldLabel: "Account holder name" },
    }),
  };
};

export const getBankSortCodeRule = (isBlank) => {
  return {
    regex: {
      pattern: SORT_CODE_REGEX,
      customMessage: "Please enter numerical values only.",
    },
    max: {
      length: 8,
      errorMessageTemplate: ERROR_MAX_LENGTH_SORT_CODE,
      fieldLabel: "Sort code",
    },
    min_length: {
      length: 8,
      errorMessageTemplate: ERROR_MIN_LENGTH_SORT_CODE,
      fieldLabel: "Sort code",
    },
    ...(!isBlank && {
      required: { fieldLabel: "Sort code" },
    }),
  };
};

export const getBankAccountNoRule = (isBlank) => {
  return {
    regex: {
      pattern: ACCOUNT_NUMBER_REGEX,
      customMessage: "Please enter numerical values only.",
    },
    min: {
      length: 8,
      fieldLabel: "Account number",
    },
    maxLength: {
      length: 8,
      fieldLabel: "Account number",
    },
    ...(!isBlank && {
      required: { fieldLabel: "Account number" },
    }),
  };
};
